module.exports = __webpack_public_path__ + "img/selectedMarker.e1dd429c.svg";